export const BlockPrivileges = (props) => {
    const {label, datas, icon, name } = props;
    let picto = 'picto';
    switch (label) {
        case 'premieraccess':
            if (datas && datas.length > 0) {
                return (
                    <div className={`${label}`}>
                        {datas.map((el, i) => {
                            picto = el.name.includes('Sans') ? 'picto disable' : 'picto';
                            return (
                                <div className={picto} key={i}>
                                    <div className="fa-stack fa-lg">
                                        <div className="fa fa-square fa-stack-2x"></div>
                                        <div className={`fa ${icon} fa-stack-1x fa-inverse`}></div>
                                    </div>
                                    {el.name}
                                </div>
                            )
                        })}
                        {datas.map((el, i) => {
                            return (
                                <div className="note" key={i}>{el.description}</div>
                            )
                        })}
                    </div>
                )
            }
        case 'pmr':
        case 'singlerider':
            return (
                <div className={label}>
                    <div className={picto}>
                        <div className="fa-stack fa-lg">
                            <div className="fa fa-square fa-stack-2x"></div>
                            <div className={`fa ${icon} fa-stack-1x fa-inverse`}></div>
                        </div>
                        {name}
                    </div>
                    <div className="note">{props.description}</div>
                </div>
            )
        case 'photopass':
            return (
                <div className={label}>
                    <div className={picto}>
                        <i className={`fa ${icon}`}></i>{name}
                    </div>
                    <div className="note">{props.description}</div>
                </div>
            )
        default:
            return (
                <></>
            )
    }
}